import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddLink(props) {
  return(
    <PostAdd 
      targetVid={"link_categories"}
      addPostEndpoint={apiEndpoints.links}
      editRoute={"/links/edit"}
      entityType={"link"}
      pageTitle={"Create a link post"}
      returnRoute={"/links-creator"}
      onlySummary={true}
    />
  )
}
